import React from 'react';
import { Link } from 'react-router-dom';
import '../../css/legal.css';

const LegalAuthFooter = () => (
    <p className="tamcare-auth-legal">
        Bằng việc sử dụng TamCare, bạn đồng ý với{' '}
        <Link to="/terms" target="_blank" rel="noreferrer">Điều khoản</Link>
        {' '}và{' '}
        <Link to="/privacy" target="_blank" rel="noreferrer">Chính sách bảo mật</Link>.
    </p>
);

export default LegalAuthFooter;
